import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  @Output() onChanged = new EventEmitter();
  @Input() placeholder = 'Search';
  @Input() value: any = '';
  @Output() onLoaded = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // Try to run this in the next tick.
    setTimeout(() => { this.onLoaded.emit(); });
  }
}
